





























import {Component, Prop} from 'vue-property-decorator'
import {VehicleSlot} from '@/lib/kepler/interfaces'
import Utils from '../utils'

import {Action} from 'vuex-class'
import {DialogState} from '@/store'
import CardButton from './CardButton.vue'
import ConfirmDialogCallback from '@/views/ConfirmDialogCallback.vue'

@Component({
  components: {
    Chip: Utils.loadComponent('proxy/Chip'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Icon: Utils.loadComponent('proxy/Icon'),
    Img: Utils.loadComponent('proxy/Image'),
    Plate: Utils.loadComponent('Plate'),
    FuelLevel: Utils.loadComponent('FuelLevel'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    Container: Utils.loadComponent('proxy/Container'),
    ProgressCircular: Utils.loadComponent('proxy/ProgressCircular'),
  },
  name: 'CardVehicleList',
})
export default class CardVehicleList extends CardButton {
  @Prop() public vehicleSlot!: VehicleSlot
  @Prop() public estimate!: number
  @Prop() public estimateLoading!: boolean
  @Action('openDialog') public openDialog: any

  public get typeKey() {
    return `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
  }

  protected canBeBooked(event: Event) {
    if (this.estimateLoading) {
      return
    }

    if (this.estimate !== null) {
      this.$emit('selectVehicle', event)
      return
    }

    this.openDialog(new DialogState(ConfirmDialogCallback, {
      code: '',
      // il tuo piano non ti permette di guidare questa categoria di veicolo
      title: this.$t('booking.your_plan_is_not_suitable'),
      subtitle: '',
      confirmText: '',
      imageState: 'warn.svg',
      confirmCallback: () => {
        return 1
      },
    }))
  }
}
